module.exports = __webpack_public_path__ + "static/testimonial-1-20f0dceae9066a4c254d1aa8828cf936.mp4";